import { render, staticRenderFns } from "./MsKhachDuLichForm.vue?vue&type=template&id=4c9b6e80&"
import script from "./MsKhachDuLichForm.vue?vue&type=script&lang=js&"
export * from "./MsKhachDuLichForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports